export const QUERY_PARAM_TEAM_INVITE_ID = 'teamInviteId';
export const QUERY_PARAM_PAGE_INVITE_ID = 'pageInviteId';
export const QUERY_PARAM_EXTERNAL_PAGE_ID = 'externalPageId';
export const QUERY_PARAM_ASK_TO_EDIT = 'askToEdit';
